// extracted by mini-css-extract-plugin
export default {"Root":"StreamEditForm_Root__js8RP"};